export const NO_DEADLINE_DATE = '9999-12-31'
export const COUNT_PER_PAGE = 100

export const categories = [
  'その他',
  '食料品',
  '消耗品',
  '衛生用品',
  '防災用品',
  '医薬品',
  '電気関係',
  '雑貨',
  '保証',
  '車関係',
  '契約',
]

export const Role = Object.freeze({
  OWNER: {
    id: 'owner',
    value: 'owner',
    name: 'アカウントオーナー',
    description: '全ての拠点の在庫、メンバー、拠点の管理',
    priority: 100,
  },
  ACCOUNT_MEMBER: {
    id: 'account-member',
    value: 'account-member',
    name: 'アカウントメンバー',
    description: '全ての拠点の在庫、メンバー（アカウントオーナーを除く）、拠点の管理',
    priority: 10,
  },
  LOCATION_MEMBER: {
    id: 'location-member',
    value: 'location-member',
    name: '拠点メンバー',
    description: '特定の拠点のメンバー、在庫の管理',
    priority: 1,
  },
})
